// Library Methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import SelectSimulationButton from "./SelectSimulationButton/SelectSimulationButton";
import SimulationSliderCard from "./SimulationSliderCard/SimulationSliderCard";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

// Contexts
import { useExamSliderContext } from "src/contexts/exams/ExamSliderContext";

// Constants
import { examCardEnums } from "src/constants/enums";

// Types
import { SelectedExamCardType } from "src/services/exams/types";

const SimulationSliderList = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);
  const { selectedExamCards, defaultSimulationOrder } = useExamSliderContext();

  const formattedSimCards: Array<SelectedExamCardType & { label: string }> =
    useMemo(
      () =>
        selectedExamCards?.map((selectedExam) => {
          const enumValues = Object.values(examCardEnums);
          const label =
            enumValues.find(
              (enumValue) =>
                enumValue.algorithmPath === selectedExam?.examFieldType
            )?.label ?? "";

          return { ...selectedExam, label };
        }),
      [selectedExamCards]
    );

  return (
    <Grid item display="flex" flexDirection="column" gap="16px">
      <Box display="flex" flexDirection="column">
        <Grid
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: "8px",
          }}
        >
          {defaultSimulationOrder.map((item) => (
            <SelectSimulationButton key={item.algorithmPath} item={item} />
          ))}
        </Grid>
      </Box>

      <Grid item display="flex" flexDirection="column" gap="16px">
        {selectedExamCards?.filter((card) =>
          card.examFieldType.includes("simulation")
        )?.length === 0 && (
          <Grid item height="82px" alignContent="center">
            <Typography color={onSurface} fontSize="16px" textAlign="center">
              {t("No Simulations Selected.")}
            </Typography>
          </Grid>
        )}

        <Grid
          item
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, 1fr)",
              sm: "repeat(2, 1fr)",
            },
            gap: "8px",
          }}
        >
          {formattedSimCards
            ?.filter((card) => card.examFieldType.includes("simulation"))
            .map((item) => {
              return (
                <SimulationSliderCard
                  key={`${item?.examFieldType}-${item?.groupId}`}
                  examAlgorithm={item?.examFieldType}
                  groupId={item?.groupId}
                />
              );
            })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SimulationSliderList;
